var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Export = function Export(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'export'
      ),
      React.createElement('path', { d: 'M7 1.5V11h1V1.5L10.5 4l.5-.625L7.5 0 4 3.375 4.5 4 7 1.5zM14 8v3.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5V8H0v3.5C0 12.878 1.122 14 2.5 14h10c1.378 0 2.5-1.122 2.5-2.5V8h-1z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Export;
//# sourceMappingURL=Export.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Export.js